import { createSlice } from "@reduxjs/toolkit";

const attendanceSlice = createSlice({
    name: 'attendance',
    initialState: {
        loading: false,
        date: null,
        records: [],
        monthly: null,
        isAttendanceSaved: false
    },
    reducers: {
        attendanceRequest(state) {
            return { ...state, loading: true };
        },
        attendanceByDateSuccess(state, action) {
            return { ...state, loading: false, date: action.payload.date, records: action.payload.records };
        },
        attendanceSavedSuccess(state) {
            return { ...state, loading: false, isAttendanceSaved: true };
        },
        clearAttendanceSaved(state) {
            return { ...state, isAttendanceSaved: false };
        },
        staffMonthlyAttendanceSuccess(state, action) {
            return { ...state, loading: false, monthly: action.payload };
        },
        attendanceFail(state, action) {
            return { ...state, loading: false, error: action.payload };
        },
        clearAttendanceError(state) {
            return { ...state, error: null };
        }
    }
});

const { actions, reducer } = attendanceSlice;

export const {
    attendanceRequest,
    attendanceByDateSuccess,
    attendanceSavedSuccess,
    clearAttendanceSaved,
    staffMonthlyAttendanceSuccess,
    attendanceFail,
    clearAttendanceError
} = actions;

export default reducer;
